import Cookies from 'js-cookie';

function setupTimer(ele, cookieNamespace) {
  let startTime = +new Date();
  let totalDuration = parseInt(ele.dataset.timerDuration);
  const timerPersistenceId = ele.dataset.timerPersistenceId;
  if (typeof(timerPersistenceId) === 'string') {
    const timerCookieId = `${cookieNamespace}_${timerPersistenceId}`;
    const cookieStartTime = parseInt(Cookies.get(timerCookieId));
    if (cookieStartTime > 0) {
        startTime = cookieStartTime;
    } else {
      Cookies.set(timerCookieId, startTime);
    }
  }


  const handler = () => {
    let seconds = parseInt(totalDuration - Math.round(((+new Date()) - startTime) / 1000.0));
    if (seconds <= 0) {
      seconds = 0;
      clearInterval(interval);
    }
    const hours = Math.floor(seconds / 3600);
    seconds -= hours*3600;
    const minutes = Math.floor(seconds / 60);
    seconds -= minutes*60;
    ele.innerText = [ hours, minutes, seconds ].map(x => x.toString().padStart(2, '0')).join(":").replace(/^00:/, '');
  };
  const interval = setInterval(handler, 1000);
}


export function setupTimers(cookieNamespace) {
  [...document.getElementsByClassName('checkout-timer')].forEach(x => setupTimer(x, cookieNamespace));
}
